import { mapState, mapGetters } from 'vuex'
import { generateMetaInfo } from '../../common'

import Title from 'components/Title'
import Breadcrumbs from 'components/Breadcrumbs'
import FlexContent from 'components/FlexContent'

export default {
  name: 'ErrorView',
  computed: {
    ...mapState(['error']),
    ...mapGetters(['lang', 'getStringTranslation', 'loading', 'getPageBySlug', 'options']),
    page () {
      return this.getPageBySlug('error')
    },
    pageTitle () {
      return this.page.page_title_override ? this.page.page_title_override : this.page.title.rendered
    }
  },
  methods: {
    getTranslation (translationTitle) {
      return this.getStringTranslation(translationTitle)
    }
  },
  metaInfo () {
    // don't do alternate and canonical etc...
    const page = this.page
    const metaInfo = page ? generateMetaInfo(this.options, this.page, { error: this.error.status }) : { meta: [] }
    return metaInfo
  },
  render (h) {
    return (
      <div class='page'>
        <Breadcrumbs page={this.page} />
        <Title level={1}>
          {this.error.status && this.error.status !== 404
            ? `${this.getTranslation('error_occured')} (${this.error.status})`
            : this.getTranslation('error_404')
          }
        </Title>
        {this.page.c_flex_content && this.page.c_flex_content.length
          ? (<FlexContent componentData={this.page.c_flex_content} />)
          : null
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/views/Error/index.js